import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from '@/App';
import { initConsoleDiagnostics } from '@/lib/console-diagnostics';
import { bootstrapBranding } from '@/contexts/branding-context';
import {
  handleVitePreloadError,
  initChunkRecoveryFromUrl,
  scheduleChunkRecoverySuccessClear,
} from '@/lib/chunk-recovery';
import { applyThemeToDocument, readStoredResolvedTheme } from '@/lib/user-theme';
import '@/styles.css';

// Capture failures during the first render before App effects have run.
initConsoleDiagnostics();

// Recover from stale hashed chunks after deploy (Safari is especially prone to this).
window.addEventListener('vite:preloadError', handleVitePreloadError);

applyThemeToDocument(readStoredResolvedTheme() ?? 'system');

// Branding fetch runs in parallel with first paint (BrandingProvider also refreshes).
void bootstrapBranding();

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Persist recovery attempt before stripping `_chunk_reload` (lazy chunks load after this runs).
initChunkRecoveryFromUrl();
scheduleChunkRecoverySuccessClear();
